"use client";

import { useBriefBuildHandlers } from "./use-brief-build-handlers";

/**
 * Single home for all shop realtime (Redis pub/sub) reactions pushed from the
 * backend over the oRPC stream. Mounted once under ShopEventsProvider; add a new
 * reaction by writing a handler hook and calling it here — no extra provider or
 * JSX wrapper per event.
 */
export const ShopRealtimeHandlers = () => {
  useBriefBuildHandlers();
  return null;
};
